<nb-card class="page-wrapper">
  <nb-card-header class="page-header bg-white d-flex flex-column">
    <button (click)="closeDialog()" class="btn border-0 m-0 p-0 w-100 text-end mt-1">
      <i class="bi bi-x-square-fill m-0"></i>
    </button>
    <p class="w-100 text-center tw-text-xl tw-font-medium main-color">
      {{ 'Service Mode' | translate }}
    </p>
  </nb-card-header>
  <nb-card-body class="page-body">
    <form
      action="javascript:"
      class="reset"
      [formGroup]="form"
      [ngClass]="{ 'was-validated': submitted, rtl: language.isArabic }"
      class="p-3 pb-0">
      <div class="my-2">
        <label class="form-label">{{ 'Service Mode' | translate }}</label>
        <select
          class="form-select input-control"
          formControlName="service_mode"
          required
          [ngClass]="{ 'is-invalid': submitted && form.get('service_mode')?.errors }">
          <option *ngFor="let option of serviceModeOptions" [ngValue]="option.value">
            {{ option.title | translate }}
          </option>
        </select>
      </div>

      <div>
        <button
          (click)="submit()"
          type="button"
          class="btn text-white tw-text-base tw-font-medium w-100 py-3 secondary-background-color tw-rounded-2xl">
          {{ 'Update Service Mode' | translate }}
        </button>
      </div>
    </form>
  </nb-card-body>
</nb-card>
